import { render, staticRenderFns } from "./shopping-cart-summary.vue?vue&type=template&id=efecce64&scoped=true&"
import script from "./shopping-cart-summary.vue?vue&type=script&lang=js&"
export * from "./shopping-cart-summary.vue?vue&type=script&lang=js&"
import style0 from "./shopping-cart-summary.vue?vue&type=style&index=0&id=efecce64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efecce64",
  null
  
)

export default component.exports